import tw, { styled } from "twin.macro"

export const FullscreenGalleryUIButton = styled.button`
  ${tw`px-2 py-2 border rounded-md border-primary text-primary`}
  ${tw`focus:(outline-none ring-primary)`}
`
